import { FC } from 'react'
import { FightEvent, FightSegment } from 'web/data/models'
import { sortFightEvents } from 'web/utils/sort-utils'
import { decorateNameWithOrdinal } from 'web/utils/text-utils'
import { FightSegmentItem, FightSegmentItemProps } from './FightSegmentItem'

type FightSegmentListProps = {
    segments: FightSegment[]
    events: FightEvent[]
    segmentProps: Omit<FightSegmentItemProps, "segment" | "events" | "allEvents" | "showSegmentHeader">
}

export const FightSegmentList: FC<FightSegmentListProps> = (props) => {

    const { segments, events, segmentProps } = props

    const segmentEvents = (segId: string) => {
        return events
            .filter(e => e.fightSegmentId === segId)
            .sort(sortFightEvents)
    }

    return (
        <>
            {segments.map(segment => (
                <FightSegmentItem
                    {...segmentProps}

                    showSegmentHeader={true}

                    key={segment.id}
                    segment={segment}
                    events={segmentEvents(segment.id)}

                    decorateNameWithOrdinal={(event) => {
                        return decorateNameWithOrdinal(events, event)
                    }}
                />
            ))}
        </>
    )
}


